<div class="container p-3 rounded">
    <div class="row">
      <section class="col-12 centrar banner">
        <h5>Selecciona la localidad que deseas comprar</h5>
        <hr class="aaaa mb-1">
      </section>
  
      <div class="col-12">
        <div class="localidades-lista">
  
          <div *ngFor="let localidad of localidadesFiltradas" class="localidad-row">
            <div class="localidad-col"><strong>{{ localidad.nombre }}</strong></div>
            <div class="localidad-col descripcion">{{ localidad.descripcion || 'Descripción' }}</div>
            <div class="localidad-col accion text-center">
              <button (click)="cantidadBoletas(localidad)" class="btnB p-2">Seleccionar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  